import { useRecoilState, useRecoilValue } from 'recoil';

import {
  hasSelectedPriceFilterSelector,
  priceFilterDefaultState,
  priceFilterState,
  searchPriceTypesState,
  selectedPriceFilterLabelSelector,
  selectedPriceFilterSelector,
} from '@/states/filters/price.state';

export function usePriceFilter() {
  const [defaultPriceFilter, setDefaultPriceFilter] = useRecoilState(
    priceFilterDefaultState
  );
  const [searchPriceTypeFilter, setSearchPriceTypeFilter] = useRecoilState(
    searchPriceTypesState
  );
  const [priceFilter, setPriceFilter] = useRecoilState(priceFilterState);
  const [selectedPriceFilter, setSelectedPriceFilter] = useRecoilState(
    selectedPriceFilterSelector
  );
  const selectedPriceFilterLabel = useRecoilValue(
    selectedPriceFilterLabelSelector
  );
  const hasSelectedPriceFilter = useRecoilValue(hasSelectedPriceFilterSelector);
  const resetPriceFilter = () => {
    const defaultRange = { min: 0, max: 0 };

    setPriceFilter(defaultRange);
    setSelectedPriceFilter(defaultRange);
  };

  return {
    defaultPriceFilter,
    setDefaultPriceFilter,
    priceFilter,
    setPriceFilter,
    setSelectedPriceFilter,
    selectedPriceFilterLabel,
    hasSelectedPriceFilter,
    resetPriceFilter,
    selectedPriceFilter,
    searchPriceTypeFilter,
    setSearchPriceTypeFilter,
  };
}
